import {CrosswordDataType} from "@/types/crosswords";
import Button from "@/components/UI/Button/Button";
import Icon from "@/components/UI/Icon/Icon";
import Modal from "@/components/UI/Modal/Modal";
import {useEffect, useState} from "react";
import Input from "@/components/UI/Input/Input";
import WordsService from "@/services/words.service";
import {WordType} from "@/types/words";
import Dimmer from "@/components/UI/Dimmer/Dimmer";
import {googleSearchFromWord, SCRYFALL_SEARCHABLE_CATEGORIES, scryfallSearchFromWord} from "@/utils/scryfall";
import CrosswordService from "@/services/crossword.service";

type Props = {
  crossword: CrosswordDataType
  clue: string
  word: string
  direction: 'across' | 'down'
  index: number
}

const EditClueModal = ({crossword, clue, word, direction, index}: Props) => {
  const [open, setOpen] = useState<boolean>(false)
  const [localClue, setLocalClue] = useState<string>(clue)
  const [loading, setLoading] = useState<boolean>(false)
  const [wordData, setWordData] = useState<WordType | null>(null)

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setLocalClue(e.target.value)
  }

  const handleCancel = () => {
    setLocalClue(clue)
    setOpen(false)
  }

  const handleSave = () => {
    setLoading(true)
    CrosswordService.saveClue(localClue, crossword, direction, index, word)
      .then(() => setOpen(false))
      .catch(e => console.error(e))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!open) return
    setLoading(true)
    WordsService.getWord(word)
      .then((w) => {
        setWordData(w)
      })
      .catch(e => console.error(e))
      .finally(() => setLoading(false))
  }, [open]);


  return (
    <>
      <Button onClick={() => setOpen(true)}><Icon icon="penToSquare"/></Button>
      <Modal
        onClose={() => setOpen(false)}
        open={open}
        header={`Edit Clue for ${word}`}
        closeIcon
        footer={<>
          <Button color="grey" onClick={handleCancel}>Cancel</Button>
          <Button disabled={clue === localClue} onClick={handleSave}>Save</Button>
        </>}
      >
        <div>
          {loading && <Dimmer loading/> }
          <label>Clue for "{word}":</label>
          <Input type="text" value={localClue} onChange={handleInputChange}/>
        </div>
        {!loading && !wordData && <p>Word not found in our database</p>}
        {wordData && (
          <>
            <h3>In our database:</h3>
            <div>
              <b>Word:</b> {wordData.word}
              <br/>
              <b>Created By:</b> {wordData.createdBy}
              <br/>
              <b>Category:</b> {wordData.category}
              <br/>
              <b>Possible Clues:</b>
              {!!wordData.hints.length &&
                <ul>
                  {wordData.hints.map((c, i) => <li key={i}>{c} <a onClick={() => setLocalClue(c)}> - Use this...</a>
                  </li>)}
                </ul>
              }
              {!wordData.hints.length && <i>No clues found in our database.</i>}
              <br/>
              <br/>
              {SCRYFALL_SEARCHABLE_CATEGORIES.includes(wordData.category) ? (
                  <a href={scryfallSearchFromWord(wordData)} target="_blank" rel="noreferrer">
                    <Button color="purple"><Icon icon="arrowUpRightFromSquare"/> Search Scryfall</Button>
                  </a>
                )
                :
                <a href={googleSearchFromWord(wordData)} target="_blank" rel="noreferrer">
                  <Button color="blue"><Icon icon="arrowUpRightFromSquare"/> Search Google</Button>
                </a>}
            </div>
          </>

        )}
      </Modal>
    </>
  )
}

export default EditClueModal;

